import { publicApi } from '@network/remote';
import { localeSelector, type LanguageCode } from './LocaleSelector';

export const appConfig = {
    now: '',
    apiDomain: 'https://api-goats.plaync.com',
    wstatic: 'https://assets.playnccdn.com',
    service: 'l2m',
    locale: 'ko-kr',
};

export const setConfig = (_config: { apiDomain: string; wstatic: string; service: string; now: string }) => {
    const htmlEl = document.querySelector('html');
    publicApi.defaults.baseURL = _config.apiDomain;
    appConfig.now = _config.now;
    appConfig.service = _config.service;
    appConfig.wstatic = _config.wstatic;
    appConfig.apiDomain = _config.apiDomain;
    appConfig.locale = localeSelector((htmlEl?.getAttribute('lang') as LanguageCode) || 'ko');
};
